export default "<button title=\"{{'BUTTONS.SAVE' | translate}}\" class=\"btn btn-success\" (click)=\"save()\">{{'BUTTONS.SAVE' | translate}}</button>\r\n";